/**
 * MIGRATED: Geolocation para pages/home usando @a365/core
 * 
 * @deprecated Este contexto ha sido migrado a @a365/core
 * Por favor use directamente LocationProvider de @a365/core
 * Fecha de migración: 2025-05-29
 */

import React from "react";
import { 
  LocationProvider as CoreLocationProvider, 
  useLocation as useCoreLocation
} from "@a365/core";

// Advertencia de deprecación
console.warn(
  'DEPRECATION WARNING: Geolocation en pages/home está deprecated. ' +
  'Por favor migre a uso directo de @a365/core LocationProvider.'
);

// Re-exportar para mantener compatibilidad (Geolocation -> Location)
export const useLocation = useCoreLocation;

// Alias para compatibilidad hacia atrás
export const LocationProvider = ({ children }) => {
  return (
    <CoreLocationProvider>
      {children}
    </CoreLocationProvider>
  );
};
